export function initSearchSidebarService() {
    const input = document.querySelector<HTMLInputElement>('.input-search_service');
    const servicesMenu = document.querySelector<HTMLElement>('.services-menu');
    const header = document.querySelector<HTMLElement>('.header');

    if (input && servicesMenu) {
        // Фокус → скроллим с учётом header
        input.addEventListener('focus', () => {
            const headerHeight = header?.offsetHeight ?? 0;
            const inputRect = input.getBoundingClientRect();
            const scrollTop = window.pageYOffset + inputRect.top - headerHeight;

            window.scrollTo({
                top: scrollTop,
                behavior: 'smooth'
            });
        });

        // Поиск
        input.addEventListener('input', () => {
            const query = input.value.trim().toLowerCase();

            const lists = servicesMenu.querySelectorAll<HTMLUListElement>('.services-items');
            lists.forEach(list => {
                const items = list.querySelectorAll<HTMLLIElement>('.services-item');
                let visibleCount = 0;

                // Фильтруем li
                items.forEach(item => {
                    const link = item.querySelector<HTMLAnchorElement>('.services-link');
                    if (!link) return;

                    const match = query.length < 3 || link.textContent?.toLowerCase().includes(query);
                    item.style.display = match ? '' : 'none';
                    if (match) visibleCount++;
                });

                // Скрываем/показываем ul
                list.style.display = visibleCount > 0 ? '' : 'none';

                // Скрываем/показываем sidebar-пункт
                const listId = list.id;
                const sidebarLink = document.querySelector<HTMLAnchorElement>(
                    `.sidebar-menu__link[href="#${listId}"]`
                );
                if (sidebarLink) {
                    const sidebarItem = sidebarLink.closest<HTMLLIElement>('.sidebar-menu__item');
                    if (sidebarItem) sidebarItem.style.display = visibleCount > 0 ? '' : 'none';
                }
            });
        });
    }
}
